import styled, { css } from "styled-components";
import Link from "next/link";
import { Device } from "../../../../styles/screenSizes";
import { colors } from "../../../../styles/variables";

interface StyledMenuProps {
  isMobileMenuOpen: boolean;
  hasSubNavs?: boolean;
}

export const StyledMenu = styled.div<StyledMenuProps>`
  @media ${Device.laptop} {
    color: ${({ theme }) => theme.color.text};
    position: relative;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  @media ${Device.notLaptop} {
    ${({ isMobileMenuOpen }) => !isMobileMenuOpen && `display: none;`};
    ${({ isMobileMenuOpen, hasSubNavs }) =>
      isMobileMenuOpen &&
      css`
        min-height: 100vh;
        background-color: ${({ theme }) => theme.color.disabled};
        color: ${({ theme }) => theme.color.primary};
        position: absolute;
        width: 100%;
        left: 0;
        top: ${hasSubNavs ? `110px` : `60px`};

        display: flex;
        flex-direction: column;
      `};
  }
`;

export const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
  height: 60px;

  @media ${Device.laptop} {
    color: ${({ theme }) => theme.header?.shop?.navLinkColor || colors.white};
    cursor: pointer;
    padding: 0 20px;
    margin-right: 20px;
    white-space: nowrap;

    &:hover {
      background-color: ${({ theme }) =>
        theme.header?.shop?.navLinkHover?.backgroundColor || colors.white};
      color: ${({ theme }) =>
        theme.header?.shop?.navLinkHover?.color || theme.color.primary};
    }
  }

  @media ${Device.notLaptop} {
    color: ${({ theme }) =>
      theme.header?.shop?.mobileLinkColor || theme.color.primary};
    background-color: ${({ theme }) =>
      theme.header?.shop?.backgroundColor || colors.white};
    width: 100%;
    border-bottom: 1px solid ${colors.gray200};
    padding-left: 20px;
  }
`;
